export function getMinChequeDate() {
  const d = new Date();
  d.setMonth(d.getMonth() - 1);
  return d.toISOString().split("T")[0];
}

export function getMaxChequeDate() {
  const d = new Date();
  d.setMonth(d.getMonth() + 1);
  return d.toISOString().split("T")[0];
}

/** Normalize API/DB date values for `<input type="date">`. */
export function formatDateForInput(value) {
  if (value == null || value === "") return "";
  const raw = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(raw)) return raw.slice(0, 10);
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function validateChequeEntry(formData) {
  const errors = {};

  const cheque_number = String(formData.cheque_number ?? formData.cheque_no ?? "").trim();
  const cheque_date = String(formData.cheque_date ?? "").trim();
  const bank_id = Number(formData.bank_id);
  const amount = Number(formData.amount);
  const purpose = String(formData.purpose ?? "").trim();
  const payee_name = String(formData.payee_name ?? "").trim();
  const voucher_number = String(formData.voucher_number ?? formData.voucher_no ?? "").trim();
  const account_number = String(formData.account_number ?? "").trim();
  const remarks = String(formData.remarks ?? "").trim();
  const cheque_cleared = Boolean(formData.cheque_cleared);
  const cheque_status_id = cheque_cleared ? Number(formData.cheque_status_id) : null;
  const clearance_date = cheque_cleared ? String(formData.clearance_date ?? "").trim() : "";
  const authorized_signatory_id = Number(formData.authorized_signatory_id);

  const nameRegex = /^(?!(?:.* ){2})(?!(?:.*\.){2})[a-zA-Z0-9 .]{4,100}$/;

  if (!formData.cheque_type_id || Number(formData.cheque_type_id) < 1) {
    errors.cheque_type_id = "Please select a cheque type";
  }

  if (!cheque_number) {
    errors.cheque_no = "Cheque number is required";
  } else if (!/^\d{1,15}$/.test(cheque_number)) {
    errors.cheque_no = "Cheque number must be 1–15 digits only";
  }

  if (!cheque_date || !/^\d{4}-\d{2}-\d{2}$/.test(cheque_date)) {
    errors.cheque_date = "Valid cheque date is required (YYYY-MM-DD)";
  } else if (!formData.id) {
    const minDate = getMinChequeDate();
    const maxDate = getMaxChequeDate();
    if (cheque_date < minDate || cheque_date > maxDate) {
      errors.cheque_date = `Date must be between ${minDate} and ${maxDate}`;
    }
  }

  if (!bank_id || bank_id < 1) {
    errors.bank_id = "Please select a bank";
  }

  if (!account_number) {
    errors.account_number = "Account number is required";
  }

  if (!payee_name) {
    errors.payee_name = "Payee name is required";
  } else if (!nameRegex.test(payee_name)) {
    errors.payee_name = "Must be 4–100 characters (letters, numbers, single spaces only)";
  }

  if (!purpose) {
    errors.purpose = "Purpose is required";
  }

  if (!voucher_number) {
    errors.voucher_no = "Voucher number is required";
  } else if (!/^[a-zA-Z0-9]+$/.test(voucher_number)) {
    errors.voucher_no = "Voucher number must be alphanumeric";
  }

  if (!Number.isFinite(amount) || amount < 1) {
    errors.amount = "Amount must be at least ₹1";
  }

  if (!authorized_signatory_id || authorized_signatory_id < 1) {
    errors.authorized_signatory_id = "Please select an authorized signatory";
  }

  if (cheque_cleared) {
    if (!cheque_status_id || cheque_status_id < 1) {
      errors.cheque_status_id = "Cheque status is required when marked cleared";
    }
    if (!clearance_date || !/^\d{4}-\d{2}-\d{2}$/.test(clearance_date)) {
      errors.clearance_date = "Clearance date is required when cheque is cleared";
    } else if (cheque_date && clearance_date < cheque_date) {
      errors.clearance_date = "Clearance date cannot be before cheque date";
    }
  }

  if (remarks.length > 200) {
    errors.remarks = "Remarks cannot exceed 200 characters";
  }

  const payload = {
    cheque_number,
    cheque_no: cheque_number,
    cheque_date,
    bank_id,
    account_number,
    amount,
    purpose,
    payee_name,
    voucher_number,
    voucher_no: voucher_number,
    remarks,
    cheque_status_id,
    clearance_date: clearance_date || null,
    cheque_cleared: cheque_cleared ? 1 : 0,
    authorized_signatory_id,
    cheque_type_id: Number(formData.cheque_type_id),
  };

  return {
    ok: Object.keys(errors).length === 0,
    errors,
    payload,
  };
}
